import React, { useEffect, useState } from "react";
import { Icon } from "@vds/icons";
import { Body } from "@vds/typography";
import ManualCameraUserLogin from "./manualCameraUserLogin";
import { useSelector } from "react-redux";
import "../cameraInfo.css";

const CameraInfoText = ({
  fovData,
  cameraDetails,
  isManualAdded,
  setCompanions,
}) => {
  const parentDeviceList = useSelector((state) => state.deviceReducer.deviceList);
  const companionDeviceList = useSelector((state) => state.deviceReducer.companionDeviceList)
  const [companionDetails, setCompanionDetails] = useState([]);
  const [visibility, setVisibility] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [uname, setUname] = useState("service");
  const [pass, setPass] = useState("Service.1234");

  const getCompanionNames = () => {
    if (companionDetails.length > 0) {
      return companionDetails.map((c, i) => {
        return <span key={i}>{c.name}</span>;
      });
    }
  };

  useEffect(() => {
    if (fovData && fovData.length > 0 && fovData[0]?.customdata?.mode) {
      const fovsurl = fovData[0]?.customdata?.encoders[0]?.url;
      const usrname = (fovsurl.indexOf("rtsp://") > -1) ? fovsurl.split("rtsp://")[1].split(":")[0]: fovsurl.split(":")[0];
      const passwrd = (fovsurl.indexOf("rtsp://") > -1) ? fovsurl.split("rtsp://")[1].split(":")[1].split("@")[0] : fovsurl.split(":")[1]?.split("@")[0] ?? "";
      if(usrname === decodeURIComponent(usrname)){
      
        setUname(usrname);
        setPass(passwrd ? decodeURIComponent(passwrd) : '');      
      }else{
        
          setUname(decodeURIComponent(usrname));
          setPass(passwrd ? decodeURIComponent(passwrd) : ''); 
        
      
    }
  }
  }, [fovData]);

  useEffect(() => {
    if (
      cameraDetails?.id &&
      parentDeviceList?.length > 0 &&
      companionDetails?.length === 0
    ) {
      const list = companionDeviceList.filter((item)=>item?.id === cameraDetails?.parentdeviceid);
      if(list && list.length > 0) {
        setCompanionDetails(list);
        setCompanions(list);
      }
    }
  }, [cameraDetails, parentDeviceList]);

  const handleUserEdit = () => {
    setOpenModal(true);
  };
  return (
    <>
      <ManualCameraUserLogin
        setOpenModal={setOpenModal}
        openModal={openModal}
        fovData={fovData}
        cameraDetails={cameraDetails}
        companionDetails={companionDetails}
        username={uname}
        upass={pass}
      />
      <div className="camera-info-text__row">
        <div>
          <Body size="small" viewport="desktop" primitive="span">
            {cameraDetails?.customdata?.location?.site?.name ?? "NA"}
          </Body>
        </div>
        <div>|</div>
        {getCompanionNames() &&
          <>
            <div>
              <Body size="small" viewport="desktop" primitive="span">
                {getCompanionNames()}
              </Body>
            </div>
            <div>|</div>
            </>
          }
        <div>
          <Body size="small" viewport="desktop" primitive="span">
            {Object.keys(cameraDetails).length &&
              cameraDetails?.kind
                .split(".")
                [cameraDetails?.kind.split(".").length - 1].toUpperCase() +
                " camera"}
          </Body>
        </div>
        {isManualAdded && (
          <>
            <div>|</div>
            <div>
              <Body size="small" viewport="desktop" primitive="span">
                RTSP camera
              </Body>
            </div>
            <div>|</div>
            <div
              className="camera-info-text__icon-btn"
              data-testid="cameraInfo_setVisibilityIconButton"
              onClick={() => {
                setVisibility(!visibility);
              }}
            >
              {" "}
              <Icon
                name={visibility ? "accessibility" : "visibility-off"}
                color="#000000"
                size="medium"
              />
            </div>
          </>
        )}
        {!visibility && isManualAdded && (
          <div>
            <Body size="small" viewport="desktop" primitive="span">
              Camera credentials
            </Body>
          </div>
        )}
        {visibility && (
          <>
            <div>
              <Body size="small" viewport="desktop" primitive="span">
                <strong>Username:</strong>
              </Body>
            </div>
            <div>
              <Body size="small" viewport="desktop" primitive="span">
                {uname}
              </Body>
            </div>
            <div>
              <Body size="small" viewport="desktop" primitive="span">
                <strong>Password:</strong>
              </Body>
            </div>
            <div>
              <Body size="small" viewport="desktop" primitive="span">
                {pass}
              </Body>
            </div>
            <div
              className="camera-info-text__icon-btn"
              data-testid="cameraInfo_editUserInfoButton"
              onClick={handleUserEdit}
            >
              <Icon name="edit" size="small" color="#000000" />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default CameraInfoText;
